const maintenanceOfOrganicIntegrityQuestionnaire = {
    "title": "有機完整性維護",
    "sections": [
        {
            "subject": "鄰地使用",
            "description": ["有機生產區須有清楚的圍籬或緩衝區，以防止無意間遭禁用物質污染，或與鄰近非有機作業土地所使用之禁用物質接觸。鄰地包括作物區、牧場、住宅或休耕地等。" +
                            "緩衝區每年可依鄰地污染源的情形而改變。緩衝區必須夠大或有足夠的地勢地形（如防風林、溝渠）可避免遭鄰近區域所用之禁用物質污染。" +
                            "緩衝帶內作物應留原地不採收，或採收、儲存並以非有機名義處置且紀錄。應於農場圖上標示出緩衝帶及鄰地位置。"],
            "questions": [
                {
                    "description": "是否有緩衝帶",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [{
                        "condition": "是",
                        "description": "如有請於”緩衝帶列表”中列出您維護之特定緩衝區。",
                        "type": "oeq",
                        "format": {
                            "multiple": true,
                            "fields": ["緩衝帶類別:作物區|林線|綠籬|草", "緩衝帶寬度", "臨地使用情形", "請說明緩衝帶作物採收用途(販售、種子等)"]
                        }
                    }]
                }
            ]
        },
        {
            "subject": "防止意外污染",
            "questions": [
                {
                    "description": "若有機及緩衝帶作物的採收設備共用，如何防止採收時有機作物與緩衝帶作物的交叉污染?",
                    "type": "oeq",
                },
                {
                    "description": "您還使用哪些其他防護措施來防止意外污染?例如書面通知鄉公所、鄰地地主、農會、水利會…等。",
                    "type": "oeq"
                },
                {
                    "description": "是否於鄰近有機田區的路邊張貼”請勿噴藥”的告示?",
                    "type": "scq",
                    "options": ["是", "否"]
                },
                {
                    "description": "部分或全部田區會經常淹水嗎?(每10年超過一次)",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "若是，請列出田區編號",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "您如何監控作物污染?",
                    "type": "mcq",
                    "options": ["視覺觀察", "殘留分析", "照相", "基因改造測試", "風向/風速", {"value": "其它", "elaboration": "請說明"}]
                },
                {
                    "description": "多久做一次病害的監控?",
                    "type": "mcq",
                    "options": ["每週", "每月", "每年", "需要時", {"value": "其它", "elaboration": "請說明"}]
                }
            ]
        },
        {
            "subject": "分開生產及平行生產",
            "questions": [
                {
                    "description": "是否有同時種植轉型及慣型作物?",
                    "type": "scq",
                    "options": ["是", "否"]
                },
                {
                    "description": "請附上”分開及平行生產列表”(請至附件區下載慈QF-P045(1.0)Split and Parallel Production Form分開及平行生產列表(定稿)，填寫完畢再上傳。)",
                    "type": "oeq",
                    "format": {
                        "multiple": false,
                        "fields": ["上傳檔案:file"]
                    }
                }
            ]
        },
        {
            "subject": "設備",
            "description": ["為避免混淆及污染，所有有機栽培所用之器具或設備不得殘留非有機作物及禁用物質。器具若與非有機栽培作物共用，使用於有機田區或作物前應徹底清洗。設備之清洗及清理應作成紀錄。"],
            "questions": [
                {
                    "description": "請列出用於種植、耕作、噴灑及採收等設備名稱",
                    "type": "oeq",
                    "format": {
                        "multiple": true,
                        "fields": ["設備名稱", "自有/租借/委外:自有|租借|委外", "有機和慣行共用:是|否", "設備用於有機田前如何清洗"]
                    }
                },
                {
                    "description": "設備是否經良好維護以避免機油、燃料油、液壓油等外洩?",
                    "type": "scq",
                    "options": ["是", "否"]
                },
                {
                    "description": "您是否使用噴灑機?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "若是,請說明什麼類型的噴霧器?",
                            "type": "oeq"
                        }
                    ]
                }
            ]
        },
        {
            "subject": "採收",
            "description": ["所有的容器、箱子和包裝材料不得含有合成殺菌劑、防腐劑或薰蒸劑。"],
            "questions": [
                {
                    "description": "您如何採收有機作物?",
                    "type": "scq",
                    "options": ["機器", "人工"]
                },
                {
                    "description": "有機作物是否委外採收?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "若是，請提供受託者姓名、地址",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["姓名", "地址"]
                            }
                        }
                    ]
                },
                {
                    "description": "請說明如何避免有機作物於採收中受到混淆或污染",
                    "type": "oeq"
                },
                {
                    "description": "採收時用何種容器?",
                    "type": "mcq",
                    "options": ["重力車/箱", "車廂", "木箱", "硬紙板/臘紙盒", "塑膠容器", {"value": "其它", "elaboration": "請說明"}]
                }
            ]
        },
        {
            "subject": "採收後處理",
            "description": ["有有機產品於採收後的處理過程不得受到非有機作物或禁用物質的污染。於農場內的加工，可能需要申請有機加工驗證。"],
            "questions": [
                {
                    "description": "請說明採收後的處理流程及使用的設備",
                    "type": "oeq"
                },
                {
                    "description": "如適用可附上附件說明",
                    "type": "oeq",
                    "format": {
                        "multiple": false,
                        "fields": ["上傳附件:file, optional, multiple"]
                    }
                },
                {
                    "description": "加工場所和設備是否為有機和非有機共用?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "若是，請說明您避免混淆和污染的方法",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "包裝是否可讓有機產品避免受到污染?",
                    "type": "scq",
                    "options": ["是", {"value": "否", "elaboration": "請說明"}]
                },
                {
                    "description": "請勾選包裝材料類型",
                    "type": "mcq",
                    "options": ["散裝", "紙", "硬紙板", "木材", "玻璃", "天然纖維", "塑膠", "臘紙", "無菌包裝", "合成纖維", "金屬", {"value": "其它", "elaboration": "請說明"}]
                },
                {
                    "description": "成品用什麼形式運送?",
                    "type": "scq",
                    "options": ["乾貨散裝", "液態散裝", "提袋", "鋁箔袋", "提箱", "硬紙筒", "紙袋", "金屬桶", "網袋", "硬紙箱", "塑膠箱", {"value": "其它", "elaboration": "請說明"}]
                },

            ]
        },
        {
            "subject": "作物儲藏",
            "description": ["有機處理作業的處理業者，必須實行必要的措施、以防止有機和非有機產品的混雜，以及保護有機產品免於與禁用物質接觸。"],
            "questions": [
                {
                    "description": "請說明儲存地點",
                    "type": "oeq"
                },
                {
                    "description": "有機、緩衝帶和慣行的作物是否儲放於同一場所?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "若是，請在下方說明您如何區隔有機作物和非有機作物?",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "儲藏有機作物前如何清潔儲存空間?",
                    "type": "oeq"
                },
                {
                    "description": "儲藏場所是否有蟲害問題?",
                    "type": "scq",
                    "options": ["是", "否"]
                },
                {
                    "description": "儲藏場所如何防治鼠/蟲害?",
                    "type": "oeq"
                },
                {
                    "description": "過去三年間使用何種資材於作物儲存?",
                    "type": "scq",
                    "options": ["無", "催熟劑", "滅鼠劑", "化學薰蒸劑", "油", "蠟", "著色劑", "發芽抑制劑", "生長調節劑", "防腐劑", {"value": "其他", "elaboration": "請說明"}]
                },
                {
                    "description": "是否使用或預計使用任何資材於有機作物的儲存?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description" :"若是，請註明並保留標籤",
                            "type": "oeq"
                        }
                    ]
                }
            ]
        },
        {
            "subject": "運輸",
            "questions": [
                {
                    "description" : "誰負責有機產品的運輸?",
                    "type": "scq",
                    "options": ["自行運送", "買方", {"value": "其它", "elaboration": "請說明"}]
                },
                {
                    "description": "您在有機作物運輸過程中有何潛在的污染或混淆問題?",
                    "type": "oeq"
                },
                {
                    "description": "運輸過程中如何確保有機產品的有機完整性?",
                    "type": "mcq",
                    "options": ["有機專用", "運送前車輛檢查", "裝載前先清洗運輸工具", "運輸公司清潔聲明", "與運輸公司以書面/合約述明有機要求", {"value": "其它", "elaboration": "請說明"}]
                }
            ]
        },
        {
            "subject": "行銷",
            "description": ["基於美國－加拿大對等協議所生產，出口有機產品其有機驗證證書必須顯示“Certified in compliance with the terms of the US-Canada Organic Equivalency Arrangement”的聲明。(僅適用於申請NOP)\n"],
            "questions": [
                {
                    "description": "行銷方式",
                    "type": "mcq",
                    "options": ["農夫市場", "直接零售", "宅配", "批發", "在農場銷售", "契作", "農產品加工", {"value": "其它", "elaboration": "請說明"}]
                },
                {
                    "description": "請列出依據美國 - 加拿大對等協議出口之產品:",
                    "type": "oeq",
                }
            ]

        }
    ]

}

export default maintenanceOfOrganicIntegrityQuestionnaire;